import React, { useEffect, useState } from 'react';
import { fetchCategories, deleteCategory } from '../../../components/API/Store/categoryAPI';
import AddEditCategory from './AddEditCategory';
import './ListCategories.css';

const ListCategories = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [editingId, setEditingId] = useState(null);
    const [isAdding, setIsAdding] = useState(false);

    useEffect(() => {
        loadCategories();
    }, []);

    const loadCategories = async () => {
        setLoading(true);
        setError('');
        try {
            const { success, categories, message } = await fetchCategories();
            if (success) {
                setCategories(categories);
            } else {
                setError(message);
            }
        } catch (err) {
            setError('An error occurred while fetching categories.');
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this category?')) {
            setLoading(true);
            setError('');
            try {
                const { success, message } = await deleteCategory(id);
                if (success) {
                    await loadCategories();
                } else {
                    setError(message);
                }
            } catch (err) {
                setError('An error occurred while deleting the category.');
            } finally {
                setLoading(false);
            }
        }
    };

    const handleEdit = (id) => {
        setEditingId(id);
        setIsAdding(false);
    };

    const handleAdd = () => {
        setIsAdding(true);
        setEditingId(null);
    };

    const handleSave = async (savedCategory) => {
        await loadCategories();
        setEditingId(null);
        setIsAdding(false);
    };

    const handleCancel = () => {
        setEditingId(null);
        setIsAdding(false);
    };

    if (loading && categories.length === 0) {
        return <div className="loading">Loading categories...</div>;
    }

    if (isAdding || editingId !== null) {
        return (
            <AddEditCategory
                id={editingId}
                onSave={handleSave}
                onCancel={handleCancel}
            />
        );
    }

    return (
        <div className="list-categories-container">
            <div className="list-categories">
                <h2>Categories</h2>
                {error && <div className="error-message">{error}</div>}
                <button onClick={handleAdd} className="btn-add">Add New Category</button>
                {categories.length === 0 ? (
                    <p>No categories found.</p>
                ) : (
                    <ul>
                        {categories.map(category => (
                            <li key={category.id}>
                                <span className="category-name">{category.name}</span>
                                <div className="category-actions">
                                    <button onClick={() => handleEdit(category.id)} className="btn-edit">Edit</button>
                                    <button onClick={() => handleDelete(category.id)} className="btn-delete">Delete</button>
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default ListCategories;